import Cookies from 'js-cookie'
import constants from '@constants'
import cartCreateMutation from './mutations/cart-create'
import { FetcherOptions } from './types'

export const cartCreate = async (
  fetch: <T = any, B = Body>(options: FetcherOptions<B>) => Promise<T>,
  lines: any[]
): Promise<any> => {
  const {
    COUNTRY_CODE,
    SITE_DOMAIN,
    SHOPIFY_COOKIE_EXPIRE,
    SHOPIFY_CART_ID_COOKIE,
  } = constants

  const { cartCreate } = await fetch({
    query: cartCreateMutation,
    variables: {
      input: { lines, buyerIdentity: { countryCode: COUNTRY_CODE } },
    },
  })

  const cart = cartCreate?.cart

  if (cart) {
    const cartId = cart.id
    const options = { expires: SHOPIFY_COOKIE_EXPIRE, domain: SITE_DOMAIN }
    Cookies.set(SHOPIFY_CART_ID_COOKIE, cartId, options)
  }

  return cartCreate!
}

export default cartCreate
